import { __extends } from "tslib";
import ClosetObject from '../ClosetObject';
import EventDetachHandle from './EventDetachHandle';
import DispatchBridge from './DispatchBridge';
import { ltjsModule, initializeWrapper } from '../ltjsEnvironment';
//
// Initialize the portable event types
//
var ALL = -1;
var NONE = -1;
initializeWrapper(function () {
    /* tslint:disable:no-unsafe-any */
    ALL = ltjsModule.module._ltjs_commons_EventDispatcher_ALL();
    NONE = ltjsModule.module._ltjs_commons_EventDispatcher_NONE();
    /* tslint:enable:no-unsafe-any */
});
var EventDispatcher = /** @class */ (function (_super) {
    __extends(EventDispatcher, _super);
    function EventDispatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EventDispatcher, "ALL", {
        get: function () {
            return ALL;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventDispatcher, "NONE", {
        get: function () {
            return NONE;
        },
        enumerable: false,
        configurable: true
    });
    EventDispatcher.prototype.attachEvent = function (type, callback, context) {
        var bridge = new DispatchBridge(context, callback, this);
        // tslint:disable-next-line:no-unsafe-any
        ltjsModule.module._ltjs_commons_EventDispatcher_addEventListener(this._getValidClosetAddress(), type, bridge.getClosetAddress());
        return EventDetachHandle.createHandle(type, bridge);
    };
    EventDispatcher.prototype.attachEventOnce = function (type, callback, context) {
        var handle = this.attachEvent(type, function (event) {
            handle.detach();
            callback.call(context, event);
        });
        return handle;
    };
    EventDispatcher.prototype.dispatchEvent = function (portableEvent) {
        // tslint:disable-next-line:no-unsafe-any
        ltjsModule.module._ltjs_commons_EventDispatcher_dispatchEvent(this._getValidClosetAddress(), ClosetObject.getClosetAddress(portableEvent));
        return this;
    };
    EventDispatcher.prototype.attachPropertyChangeEvent = function (propertyName, callback, context) {
        var bridge = new DispatchBridge(context, callback, this);
        //
        // Put the propertyName into the closet, call the JNI method to add the listener,
        // then release the temporary closet string.
        //
        var propertyNameAddress = ltjsModule.convertStringToC(propertyName);
        // tslint:disable-next-line:no-unsafe-any
        ltjsModule.module._ltjs_commons_EventDispatcher_addPropertyChangeEventListener(this._getValidClosetAddress(), propertyNameAddress, bridge.getClosetAddress());
        ltjsModule.releasePrimitive(propertyNameAddress);
        return EventDetachHandle.createPropertyChangeHandle(propertyName, bridge);
    };
    return EventDispatcher;
}(ClosetObject));
export default EventDispatcher;
